import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";

import { Avatar, Button, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import ClipLoader from "react-spinners/ClipLoader";

import { getProductDetailsById } from "../../redux/action-creators/productAction";
import { getdatabyId } from "../../redux/action-creators/adoptionAction";

import { SidebarStyles } from "./Sidebar";
import { capitalize } from "../../utils/helper";
import { RoutingLinks, NewLineRegex, Type } from "../../utils/constants";

import minImage from "../../images/minImage.png";

import { UserCommonStyles } from "../../styles/CommonStyles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { productCountHandler } from "../header/Header";
import { toast } from "../../utils/toastsMessage";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  border: "2px solid #fff",
  boxShadow: 24,
  pb: 1,
  pt: 4,
  px: 4,
};

const style2 = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#FAF9F6",
  // border: "2px solid #fff",
  boxShadow: 24,
  pb: 1,
  pt: 4,
  px: 4,
};

const ProductSidebar = (props: {
  id: string;
  type: string;
  userList: any;
  foundUser: any;
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const styleClasses = SidebarStyles();
  // const [userList, setUserList] = useState([]);
  // const [foundUser, setFoundUser] = useState([]);
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [addToCartDisabled, setAddToCartDisabled] = useState<boolean>(false);

  let userData: any = localStorage.getItem("userData");
  userData = userData ? JSON.parse(userData) : {};

  const [open, setOpen] = useState(false);
  const [vendorAndQuantityMessageModal, setVendorAndQuantityMessageModal] =
    useState<any>({
      showModal: false,
      isDifferentVendor: false,
      isAvailableQuantity: false,
    });
  const handleOpen = () => setOpen(true);
  const handleClose = () =>
    setVendorAndQuantityMessageModal({
      showModal: false,
      isDifferentVendor: false,
      isAvailableQuantity: false,
    });

  const { id, type, userList, foundUser } = props;

  /**
   * fetch user details
   * @param id
   */
  const userDetails = useCallback(
    async (id: string) => {
      if (type === Type.product) {
        const response: any = await dispatch(getProductDetailsById(id));

        if (
          userData &&
          Object.keys(userData).length > 0 &&
          userData?.address &&
          response &&
          response?.length > 0
        ) {
          response[0].address = userData?.address;
        }
        // setUserList(response);
      } else {
        const response: any = await dispatch(getdatabyId(id, type));
        // setUserList(response?.data?.data);
        if (type === "lost&found" && response?.founderData.length > 0) {
          // setFoundUser(response?.founderData)
        }
      }
    },
    [dispatch, type, userData]
  );

  // useEffect(() => {
  //   if (data.length > 0) {
  //     setUserList(data);
  //   }
  //   // userDetails(id);
  // }, [id]);

  /**
   * Add to cart Product
   */
  const addToCartProduct = async () => {
    if (type === Type.product) {
      let obj = { different_vendor: false, notAvailableQuantity: false };
      setAddToCartDisabled(true);
      const previousData = JSON.parse(
        localStorage.getItem(Type?.shoppingBag) || "[]"
      );
      const shoppingBagData = Array.isArray(previousData) ? previousData : [];
      
      if (shoppingBagData.length) {
        shoppingBagData.forEach((ele: any) => {
          if (ele?.seller_id !== userList[0]?.userId)
            obj.different_vendor = true;
          if (
            ele?.product_id === userList[0]?.id &&
            userList[0]?.product_quantity <= ele?.order_quantity
          )
            obj.notAvailableQuantity = true;
        });
        if (obj.different_vendor) { // Check different vendor
          setAddToCartDisabled(false);
          setVendorAndQuantityMessageModal({
            showModal: true,
            isDifferentVendor: true,
            isAvailableQuantity: false,
          });
        } else if (obj.notAvailableQuantity) { // check available quantity                
          setAddToCartDisabled(false);
          setVendorAndQuantityMessageModal({
            showModal: true,
            isDifferentVendor: false,
            isAvailableQuantity: true,
          });
        } else {
          const findExistingProductIndex = shoppingBagData.findIndex(
            (ele: any) => ele?.product_id === userList[0]?.id
          );
          if (findExistingProductIndex !== -1) {
            if (shoppingBagData[findExistingProductIndex]) {
              shoppingBagData[findExistingProductIndex].order_quantity += 1;
              localStorage.setItem(
                Type?.shoppingBag,
                JSON.stringify(shoppingBagData)
              );
              productCountHandler(shoppingBagData?.length);
              history.push(`${RoutingLinks.productDetail}${userList[0]?.id}`); // this route use for bag counter update
              handleOpen();
              setAddToCartDisabled(false);
            };
          } else {
            const product = {
              seller_id: userList[0]?.userId,
              product_id: userList[0]?.id,
              name: userList[0].name ? userList[0].name : "",
              price: userList[0]?.price ? userList[0].price : 0,
              order_quantity: 1,
              available_quantity: userList[0]?.product_quantity,
              product_image: userList[0]?.gallery_images
                ? JSON.parse(userList[0]?.gallery_images)[0]
                : "",
            };
            shoppingBagData.unshift(product);
            localStorage.setItem(
              Type?.shoppingBag,
              JSON.stringify(shoppingBagData)
            );
            productCountHandler(shoppingBagData?.length);
            history.push(`${RoutingLinks.productDetail}${userList[0]?.id}`); // this route use for bag counter update
            setAddToCartDisabled(false);
            handleOpen();
          }
        }
      } else {
        const product = {
          seller_id: userList[0]?.userId,
          product_id: userList[0]?.id,
          name: userList[0].name ? userList[0].name : "",
          price: userList[0]?.price ? userList[0].price : 0,
          order_quantity: 1,
          available_quantity: userList[0]?.product_quantity,
          product_image: userList[0]?.gallery_images
            ? JSON.parse(userList[0]?.gallery_images)[0]
            : "",
        };
        shoppingBagData.unshift(product);
        localStorage.setItem(
          Type?.shoppingBag,
          JSON.stringify(shoppingBagData)
        );
        productCountHandler(shoppingBagData?.length);
        history.push(`${RoutingLinks.productDetail}${userList[0]?.id}`); // this route use for bag counter update
        setAddToCartDisabled(false);
        handleOpen();
      }
    }
  };

  const productOverrideHandler = () => {
    handleClose();
    const temp = [];
    const product = {
      seller_id: userList[0]?.userId,
      product_id: userList[0]?.id,
      name: userList[0].name ? userList[0].name : "",
      price: userList[0]?.price ? userList[0].price : 0,
      order_quantity: 1,
      available_quantity: userList[0]?.product_quantity,
      product_image: userList[0]?.gallery_images
        ? JSON.parse(userList[0]?.gallery_images)[0]
        : "",
    };
    temp.unshift(product);
    localStorage.setItem(
      Type?.shoppingBag,
      JSON.stringify(temp)
    );
    productCountHandler(temp?.length);
    history.push(`${RoutingLinks.productDetail}${userList[0]?.id}`); // this route use for bag counter update
    setAddToCartDisabled(false);
    handleOpen();
  }

  /**
   * order confirmed
   * @returns
   */
  // const OrderConfirmed = async () => {
  //   setShowConfirmButton(true);
  //   let sellerId = userList[0].userId;
  //   userList[0].userId = userData.id;
  //   const response: any = await dispatch(createOrder(userList[0]));
  //   if (response && response?.data?.isRegistered) {
  //     setShowConfirmButton(false);
  //     setOpen(false);
  //     userList[0].userId = sellerId;
  //     const data = { type: "New order", id: userData.id };
  //     await dispatch(sendNotification(userList[0].userId, data));
  //     return toast.success(translation(response.message));
  //   }
  //   else {
  //     setShowConfirmButton(false);
  //     setOpen(false);
  //     return toast.error(translation(response.message));
  //   }
  // };

  return (
    <Box className={`${styleClasses.SidebarMain}`}>
      {userList.length > 0 ? (
        <Box>
          <Typography variant="h6" className={commonStyle.m0}>
            {userList[0]?.name ? capitalize(userList[0].name) : null}
          </Typography>
          <Box
            style={{ marginTop: "5px" }}
            className={`${commonStyle.borderTop} ${commonStyle.blueBtn} ${commonStyle.py15}`}
          >
            {type === Type.product && (
              // <Typography className={styleClasses.smallPrice}>
              //   $ {userList[0]?.price ? userList[0].price : null}
              // </Typography>
              <>
                <Box pb={3} className={styleClasses.petDetails}>
                  <Typography className={styleClasses.petProductLabel}>
                    {"Price: "}
                  </Typography>
                  <Typography className={styleClasses.petProductDesc}>
                    {userList[0].price
                      ? `$${userList[0].price.toFixed(2)}`
                      : ""}
                  </Typography>
                </Box>
                {/* <Box pb={3} className={styleClasses.petDetails}>
                  <Typography className={styleClasses.petProductLabel}>
                    {"Available Quantity: "}
                  </Typography>
                  <Typography className={styleClasses.petProductDesc}>
                    {userList[0].product_quantity
                      ? userList[0].product_quantity
                      : "0"}
                  </Typography>
                </Box> */}
              </>
            )}
            <Button
              onClick={() =>
                history.push({
                  pathname: RoutingLinks.chat,
                  state: {
                    id: userList[0]?.userId,
                    first_name: userList[0]?.first_name,
                    last_name: userList[0]?.last_name,
                    profile_image: userList[0]?.profile_image,
                    channel: "",
                  },
                })
              }
              fullWidth
            >
              {translation("message")}
            </Button>
          </Box>

          {type === Type.product && (
            <Box className={`${commonStyle.py15} ${commonStyle.borderTop}`}>
              <Typography variant="h6" className={commonStyle.m0}>
                {translation("details")}
              </Typography>
              {userList[0]?.description ? (
                <Typography
                  className={styleClasses.smallPrice}
                  dangerouslySetInnerHTML={{
                    __html: `${userList[0]?.description.replace(
                      NewLineRegex,
                      "<br />"
                    )}`,
                  }}
                ></Typography>
              ) : (
                ""
              )}
            </Box>
          )}

          {(type === Type.adoption || type === Type["lost&found"]) && (
            <>
              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("Type_of_Pet")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.type ? translation(userList[0].type) : null}
                </Typography>
              </Box>
              {userList[0]?.type === "Dog" || userList[0]?.type === "Cat" ? (
                <Box className={styleClasses.petDetails}>
                  <Typography className={styleClasses.petProductLabel}>
                    {translation("surgical")}:
                  </Typography>
                  <Typography className={styleClasses.petProductDesc}>
                    {userList[0]?.surgical_procedure
                      ? capitalize("Spayed/Neutered")
                      : null}
                  </Typography>
                </Box>
              ) : null}
              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("breed")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.breed ? userList[0].breed : null}
                </Typography>
              </Box>

              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("description")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.description ? (
                    <p
                      className={commonStyle.m0}
                      dangerouslySetInnerHTML={{
                        __html: `${userList[0]?.description.replace(
                          NewLineRegex,
                          "<br />"
                        )}`,
                      }}
                    ></p>
                  ) : null}
                </Typography>
              </Box>

              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("color")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.color ? capitalize(userList[0].color) : null}
                </Typography>
              </Box>

              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("age")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.age ? userList[0].age : null}
                </Typography>
              </Box>

              <Box className={styleClasses.petDetails}>
                <Typography className={styleClasses.petProductLabel}>
                  {translation("location")}:
                </Typography>
                <Typography className={styleClasses.petProductDesc}>
                  {userList[0]?.address ? userList[0].address : null}
                </Typography>
              </Box>
            </>
          )}

          <Box className={`${commonStyle.py15} ${commonStyle.borderTop}`}>
            <Typography variant="h6" className={commonStyle.m0}>
              {type === Type.product
                ? translation("seller_info")
                : translation("Owner_info")}
            </Typography>

            <Box className={`${commonStyle.py15} ${commonStyle.wallUserInfo}`}>
              <Avatar
                alt={translation("story_person")}
                src={
                  userList[0]?.profile_image
                    ? userList[0].profile_image
                    : minImage
                }
              />
              <Box className={commonStyle.ml10}>
                <Typography variant="h2" className={commonStyle.white}>
                  <Link
                    to={{
                      pathname: `${RoutingLinks.profiles}${userList[0]?.userId}`,
                    }}
                    className={`${commonStyle.white} ${commonStyle.anchorDecoration}`}
                  >
                    {userList[0]?.first_name
                      ? capitalize(userList[0].first_name)
                      : null}{" "}
                    {+" " + userList[0]?.last_name
                      ? capitalize(userList[0].last_name)
                      : null}
                  </Link>
                </Typography>
                <Typography>
                  {userList[0]?.type ? translation(userList[0].type) : null}
                </Typography>
              </Box>
            </Box>
            {type === "lost&found" &&
            userList[0].status === "found" &&
            foundUser.length > 0 ? (
              <>
                <Typography variant="h6" className={commonStyle.m0}>
                  {"Founder Information"}
                </Typography>
                <Box
                  className={`${commonStyle.py15} ${commonStyle.wallUserInfo}`}
                >
                  <Avatar
                    alt={translation("story_person")}
                    src={
                      foundUser[0]?.profile_image
                        ? foundUser[0].profile_image
                        : minImage
                    }
                  />
                  <Box className={commonStyle.ml10}>
                    <Typography variant="h2" className={commonStyle.white}>
                      <Link
                        to={{
                          pathname: `${RoutingLinks.profiles}${foundUser[0]?.id}`,
                        }}
                        className={`${commonStyle.white} ${commonStyle.anchorDecoration}`}
                      >
                        {foundUser[0]?.first_name && foundUser[0]?.last_name
                          ? `${capitalize(
                              foundUser[0].first_name
                            )} ${capitalize(foundUser[0].last_name)}`
                          : ""}
                      </Link>
                    </Typography>
                  </Box>
                </Box>
              </>
            ) : null}

            {type === Type.product && (
              <>
                {userList[0].product_quantity === 0 ? (
                  <Box className={`${commonStyle.borderTop}`}>
                    <Typography
                      mt={2}
                      sx={{ fontSize: "14px" }}
                    >{`The quantity of the ${
                      userList[0].name ? `(${userList[0].name})` : ""
                    } is currently unavailable`}</Typography>
                  </Box>
                ) : null}
                {userList[0]?.userId != userData?.id ? (
                  <Box
                    className={` ${commonStyle.blueBtn} ${commonStyle.py15}`}
                  >
                    <Button
                      fullWidth
                      onClick={addToCartProduct}
                      disabled={
                        userList[0].product_quantity === 0 || addToCartDisabled
                      }
                    >
                      {"Add to Cart"}
                      {addToCartDisabled ? <ClipLoader /> : null}
                    </Button>
                  </Box>
                ) : null}
                <Modal
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  hideBackdrop={true}
                >
                  <Box sx={style}>
                    <Box className={commonStyle.textCenter}>
                      <CheckCircleIcon
                        style={{ color: "#22c3a9", fontSize: 80 }}
                      />
                    </Box>
                    <Box className={commonStyle.py15}>
                      <Box className={commonStyle.textCenter}>
                        <Typography pb={1}>
                          Product has been added to you cart
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          className={` ${commonStyle.blueBtn} ${commonStyle.py15}`}
                        >
                          <Typography>
                            <Link
                              to="/products"
                              className={commonStyle.continueShopping}
                            >
                              Continue Shopping
                            </Link>
                          </Typography>
                        </Box>
                        <Box
                          className={` ${commonStyle.blueBtn} ${commonStyle.py15}`}
                        >
                          <Button
                            fullWidth
                            onClick={() => {
                              localStorage.removeItem(
                                Type?.shoppingCartCheckout
                              );
                              history.push(RoutingLinks.checkout_step1);
                            }}
                          >
                            Proceed to checkout
                            {/* {showConfirmButton ? <ClipLoader /> : null} */}
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Modal>

                {/* Different Vendors and Quantity validate modal */}
                <Modal
                  open={vendorAndQuantityMessageModal.showModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  hideBackdrop={true}
                >
                  <Box sx={style2}>
                    <Box className={commonStyle.py15}>
                      <Box className={commonStyle.textCenter}>
                        <Typography pb={1}>
                          {vendorAndQuantityMessageModal?.isDifferentVendor
                            ? `You need to place another order for different vendors, as ordering from multiple vendors simultaneously is not allowed. However, you can override the previous product`
                            : vendorAndQuantityMessageModal?.isAvailableQuantity
                            ? `The quantity of ${
                                userList[0].name ? `the (${userList[0].name})` : "this product"
                              } is currently unavailable`
                            : ""}
                        </Typography>
                      </Box>
                      {vendorAndQuantityMessageModal?.isDifferentVendor ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "20px"
                          }}
                        >
                         
                          <Box
                            className={` ${commonStyle.blueBtn} ${commonStyle.py15}`}
                          >
                            <Button
                              fullWidth
                              onClick={productOverrideHandler}
                            >
                              {"Yes"}
                            </Button>
                          </Box>
                          <Box
                            className={`${commonStyle.blueOutlineBtn}`}
                          >
                            <Button
                              className={`${commonStyle.font16} ${commonStyle.fontWeight400}`}
                             onClick={handleClose}
                            >
                              {"No"}
                            </Button>
                          </Box>
                        </Box>
                      ) : vendorAndQuantityMessageModal?.isAvailableQuantity ? (
                        <Box
                          className={`${commonStyle.blueBtn} ${commonStyle.py15} ${commonStyle.textCenter} ${commonStyle.mt10}`}
                        >
                          <Button
                            className={`${commonStyle.btnpy1060}`}
                            onClick={handleClose}
                          >
                            {"Ok"}
                          </Button>
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                </Modal>
              </>
            )}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default ProductSidebar;
